// Centralized TanStack Query key factory. Keeps cache keys consistent across hooks
// and makes targeted invalidation explicit and type-safe.

export const qk = {
  auth: {
    profile: ['auth', 'profile'] as const,
    branchContext: ['auth', 'branch-context'] as const,
  },

  countries: (params?: unknown) => ['countries', params ?? 'all'] as const,

  files: {
    all: ['files'] as const,
    list: (params: unknown) => ['files', 'list', params] as const,
    detail: (id: number) => ['files', 'detail', id] as const,
  },
  folders: ['folders'] as const,

  users: {
    all: ['users'] as const,
    detail: (id: number) => ['users', 'detail', id] as const,
    roles: (id: number) => ['users', id, 'roles'] as const,
    emailHistory: (id: number) => ['users', id, 'email-history'] as const,
  },
  roles: {
    all: ['roles'] as const,
    permissions: (id: number) => ['roles', id, 'permissions'] as const,
  },
  permissions: ['permissions'] as const,
  branches: {
    all: ['branches'] as const,
  },
  platformTenants: {
    all: ['platform-tenants'] as const,
    list: (params: unknown) => ['platform-tenants', 'list', params] as const,
    detail: (id: number) => ['platform-tenants', 'detail', id] as const,
    profile: (id: number) => ['platform-tenants', 'profile', id] as const,
  },

  /** Platform AI Management (control plane). Separate namespace from the tenant `settings.ai*` keys. */
  platformAi: {
    all: ['platform-ai'] as const,
    providers: (params: unknown) => ['platform-ai', 'providers', params] as const,
    providerOptions: ['platform-ai', 'providers', 'options'] as const,
    configuration: ['platform-ai', 'configuration'] as const,
    models: (params: unknown) => ['platform-ai', 'models', params] as const,
  },

  /** Platform GSTIN lookup credentials (control plane). */
  platformGst: {
    all: ['platform-gst'] as const,
    credential: ['platform-gst', 'credential'] as const,
  },

  settings: {
    company: ['settings', 'company'] as const,
    branding: ['settings', 'branding'] as const,
    email: ['settings', 'email'] as const,
    whatsapp: ['settings', 'whatsapp'] as const,
    aiConfiguration: ['settings', 'ai-configuration'] as const,
    aiModels: ['settings', 'ai-configuration', 'models'] as const,
    aiProviders: ['settings', 'ai', 'providers'] as const,
    aiProviderModels: (provider: string) => ['settings', 'ai', 'models', provider] as const,
    aiUsageSummary: ['settings', 'ai-configuration', 'usage-summary'] as const,
    aiLogs: (params: unknown) => ['settings', 'ai-configuration', 'logs', params] as const,
  },
};
